<template>
  <div ref="formulaContainer" class="formula-container">
    {{ processedFormula }}
  </div>
</template>

<script>
import { renderMathInElement } from 'mathlive';

export default {
  props: {
    formula: String,
    variables: Array
  },
  computed: {
    processedFormula() {
      let processed = this.formula;

      this.variables.forEach(item => {
        const regex = new RegExp(`profitId${item.id}`, 'g');
        processed = processed.replace(regex, `\\text{${item.title}}`);
      });

      return `\\(${processed}\\)`;
    }
  },
  methods: {
    renderFormula() {
      if (this.$refs.formulaContainer) {
        renderMathInElement(this.$refs.formulaContainer);
      }
    }
  },
  mounted() {
    this.renderFormula();
  },
  updated() {
    this.renderFormula();
  }
};
</script>

<style>
.formula-container {
  direction: ltr;
  display: inline-block;
}
</style>
